import log from 'client/lib/log';

import { SR_API_ACTION_RUN_CRON_TASK } from 'api/actionTypes';

export default async function runCronTask({ apiClient }, { cronTaskName }) {
  try {
    await apiClient.post(SR_API_ACTION_RUN_CRON_TASK, { cronTaskName });
  } catch (error) {
    log.error(error);
  }
}
